<template>
    <div :class="['form-row', show ? '' : 'hide']">
        <div class="col-md-6">
            <slot name="content_type" />
            <slot name="template" />
            <slot name="redirect_url" />
            <slot name="open_in_new_tab" />
        </div>
        <div class="col-md-6 pl-5">
            <div role="group" class="form-group page-type-group"
                description="Is this a regular page you want to add content to or a link that redirect to another page/site?">
                <h3>Assign to Menus</h3>
                <p>You can choose to show or hide your page from your site menus.</p>
            </div>
            <div class="page-display-switches">
            <hr><slot name="show_in_menu" />
            <hr><slot name="show_in_responsive_menu" />
            <hr><slot name="show_in_footer" />
            <hr><slot name="secured" /><hr>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['section', 'showOnSection', 'name'],

    computed: {
        show() {
            return (this.showOnSection == this.section);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/PageDetailsFormLayout.vue